module.exports = __webpack_public_path__ + "img/xunchaguanli.790c3311.png";